import React from "react"

const Footer = () => (
  <footer>
    <span>&copy; 2018 - United States Bowling Congress. All rights reserved.</span>
    <span style={{ marginLeft:'20%' }}>Build v0.25182.3
    </span>
  </footer>
)
export default Footer



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js